import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";

import Aux from "../../../hoc/Auxiliary";

import TableContainer from "./Table/TableContainer";
import Spinner from "../../UI/Spinner";
import axios from "../../../axios-defaults";
import {Link, useHistory} from "react-router-dom";
import DateFormated from "../../Utils/Date/Date";

const Messages = (props) => {
    const {t, i18n} = useTranslation();
    const history = useHistory();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredItems, setFilteredItems] = useState([]);
    const [viewedMessage, setViewedMessage] = useState(null);

    const getMessages = async () => {
        await axios.get(`/messages`)
            .then(response => {
                // noinspection JSUnresolvedVariable
                if (response.data.succeeded) {
                    mapMessages(response.data.data.messages);
                }
            }).catch(error => {
                console.log('[Messages.js] : Communications ajax error in getMessages()', error.message)
            });
    }

    const showMessage = async (message) => {
        await readMessage(message);
        // noinspection JSUnusedAssignment
        setViewedMessage(message);
    }

    const readMessage = async (message) => {
        await axios.put('/messages/' + message.id + '/read')
            .then(response => {
                // noinspection JSUnresolvedVariable
                if (response.data.succeeded) {
                    message.read = true;
                }

                reloadMessagesAfterAction();
            }).catch(error => {
                console.log('[Messages.js] : Communications ajax error in readMessage()', error.message)
            });
    }

    const unreadMessage = async (message) => {
        await axios.put('/messages/' + message.id + '/unread')
            .then(response => {
                // noinspection JSUnresolvedVariable
                if (response.data.succeeded) {
                    message.read = false;
                }

                reloadMessagesAfterAction();
            }).catch(error => {
                console.log('[Messages.js] : Communications ajax error in readMessage()', error.message)
            });
    }

    const mapMessages = (messages) => {
        if (messages.length) {
            let itemsArr = [];

            messages.forEach((item) => {
                let newItem = {
                    id: item.id,
                    read: (item.read === 1),
                    date: item.created_at,
                    title_fr: item.title_fr,
                    message_fr: item.message_fr,
                    excerpt_fr: item.excerpt_fr,
                    title_en: item.title_en,
                    message_en: item.message_en,
                    excerpt_en: item.excerpt_en
                };
                itemsArr.push(newItem)
            });
            setItems(itemsArr);
            setFilteredItems(itemsArr);
        }
    }

    useEffect(async () => {
        setLoading(true)
        await getMessages();
        setLoading(false)

    }, []);


    useEffect(() => {


        history.listen((location) => {
            let tester = window.location.pathname;
        if ((tester.split('/')[3] !== undefined && tester.split('/')[3] !== '') && items.length > 0) {
            let item = items.find((item) => Number(tester.split('/')[3]) === item.id);
            setViewedMessage(item)
            if(!item.read){
                 readMessage(item);
            }
        }
        if((tester.split('/')[3] === undefined || tester.split('/')[3] === '')){
            setViewedMessage(null)
        }
    })
        let tester = window.location.pathname;
        if((tester.split('/')[3] !== undefined && tester.split('/')[3] !== '')&& items.length > 0){
            let item = items.find((item) => Number(tester.split('/')[3]) === item.id);
            setViewedMessage(item)
            if(!item.read){
                readMessage(item);
            }
        }
    }, [history, viewedMessage,items])


    const reloadMessagesAfterAction = async () => {
        await getMessages().then( props.updateNotifHeader());
    }

    const columns = useMemo(
        () => [
            {
                Header: t('profile.messages.list.header.title'),
                id: "title",
                accessor: "title_"+i18n.language,
                width: '100%',
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <Aux>
                                <Link
                                    to={"#"}
                                    className={`${props.cell.row.original.read ? "" : "span--weight--bold"}`}
                                    onClick={async () => {
                                        await showMessage(props.cell.row.original);
                                    }}>
                                    {props.value}
                                </Link>
                            </Aux>
                        );
                    } else {
                        return '';
                    }
                },
            },
            {
                Header: t('profile.messages.list.header.date'),
                id: "date",
                accessor: "date",
                minWidth: '260px',
                Cell: (props) => {
                    return (props.value) ? <DateFormated date={props.value} withTime={true}/> : '';
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1)
                        return 1;
                    else if (a1 > b1)
                        return -1;
                    else
                        return 0;
                }
            },
            {
                Header: t('profile.messages.list.header.status'),
                id: "status",
                accessor: "read",
                minWidth: '180px',
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <div className="status status--black"
                                 style={{textAlign: 'left', fontSize: 16, cursor: 'pointer'}} title="Read"
                                /* onClick={async () => {
                                     await unreadMessage(props.cell.row.original);
                                 }}*/>
                                <i className="fas fa-eye"></i>&nbsp;{t('communications.table.read')}
                            </div>
                        );
                    } else {
                        return (
                            <div className="status status--red"
                                 style={{textAlign: 'left', fontSize: 16, cursor: 'pointer'}} title="Not Read"
                                 /*onClick={async () => {
                                     await readMessage(props.cell.row.original);
                                 }}*/>
                                <i className="fas fa-eye-slash"></i>&nbsp;{t('communications.table.unread')}
                            </div>
                        );
                    }
                },
            },
            {
                Header: '',
                id: "action",
                accessor: "id",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <strong>
                                <Link
                                    to={`/profile/messages/${props.row.original.id}`}
                                    className="link link--fs-16 link--accent link--red  link--upper"
                                    onClick={async () => {
                                        await showMessage(props.cell.row.original);
                                    }}>
                                    {t('profile.messages.list.row.readitem')}&nbsp;&nbsp;<i
                                    className="fas fa-angle-right"></i>
                                </Link>
                            </strong>
                        );
                    } else {
                        return '';
                    }
                },
            },
        ],
        [items, t, i18n]
    );

    // noinspection JSUnusedAssignment
    let dataHtml = '';

    if (loading) {
        dataHtml = <Spinner/>;
    } else {
        dataHtml = (
            <Aux>
                <div className="message-profile-head">
                    <h2 className="headline headline--section headline--uppercase">
                        {t("profile.messages.title")}
                    </h2>
                </div>
                {filteredItems.length !== 0 ?  <TableContainer
                    columns={columns}
                    data={filteredItems}
                /> : <strong>{t("profile.messages.nonotification")}</strong>}

            </Aux>
        );
    }

    return (
        <Aux>

            {viewedMessage === null ?
                dataHtml
                :
                <React.Fragment>
                    <div className="message-profile-head">
                        <button
                            className="btn btn--raised btn--raised--red"
                            onClick={() => {
                                let tester = window.location.pathname;
                                if ((tester.split('/')[3] !== undefined &&
                                    tester.split('/')[3] !== '')) {
                                    tester = tester.substring(0, tester.lastIndexOf('/'));
                                    window.history.pushState({}, null, tester);
                                }
                                setViewedMessage(null);
                            }}
                        ><i className="far fa-angle-left"></i>&nbsp;&nbsp;
                            {t('profile.messages.viewed_message.back_to_list')}</button>
                        <br/>
                        <br/>
                        <h2 className="headline headline--section headline--uppercase headline--margin--20">
                            {viewedMessage['title_'+i18n.language]}
                        </h2>
                    </div>
                    <div className="mb-3"><strong>{t('profile.messages.list.header.date')}&nbsp;:&nbsp;</strong><DateFormated date={viewedMessage.date} withTime={true}/></div>
                    <div dangerouslySetInnerHTML={{__html: viewedMessage['message_'+i18n.language]}}></div>
                </React.Fragment>
            }
        </Aux>
    );
};

export default Messages;
